module.exports = __webpack_public_path__ + "static/img/70-1.f948a3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/70-1.jpg
// module id = DLF3
// module chunks = 0